import { message } from "antd";
import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const REACT_APP_SESSION_EXPIRY_TIME = process.env.REACT_APP_SESSION_EXPIRY_TIME || 60 * 1000;

const AuthContext = createContext<any>(null!);

function getInitialUser() {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
}

function getInitialAuth() {
  const auth = localStorage.getItem("auth");
  return auth ? JSON.parse(auth) : null;
}

function getInitialToken() {
  const token = localStorage.getItem("token");
  return token ? token : null;
}

const AuthProvider = ({ children, location }: any) => {
  const [user, setUser] = useState<any>(getInitialUser);
  const [auth, setAuth] = useState<any>(getInitialAuth);
  const [token, setToken] = useState<any>(getInitialToken);

  const navigate = useNavigate();


  const signin = (payload: any) => {
    const { user, token, auth } = payload;

    const expiresAt = Date.now() + Number(REACT_APP_SESSION_EXPIRY_TIME);

    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("auth", JSON.stringify(auth));
    localStorage.setItem("token", token);
    localStorage.setItem("expiresAt", expiresAt.toString());

    setUser(user);
    setAuth(auth);
    setToken(token);

    navigate("/dashboard");
  };


  const clearAuth = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("auth");
    localStorage.removeItem("token");
    localStorage.removeItem("expiresAt");

    setUser(null);
    setAuth(null);
    setToken(null);
  };

  const signout = () => {
    clearAuth();
    navigate("/");
    message.success("Logged out successfully");
  };


  const handleFetchAuth = () => {
    const expiresAt = localStorage.getItem("expiresAt");

    if (!expiresAt || Date.now() > Number(expiresAt)) {
      clearAuth();
      navigate("/");
      return;
    }

    setUser(getInitialUser());
    setAuth(getInitialAuth());
    setToken(getInitialToken());
  };

  let value = {
    user,
    setUser,
    auth,
    setAuth,
    token,
    setToken,
    signin,
    signout,
  };

  useEffect(() => {
    handleFetchAuth();
  }, []);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export { AuthContext, AuthProvider };
